<template >
    <div class="section">
        <div class="bak">
            <h1 class="title is-size-2 is-size-3-mobile has-text-primary">Kontakt oss</h1>
            <div class="columns is-centered" style="margin-top:3vw;">
                <div class="column is-one-third">
                    <p class="is-size-4 is-size-5-mobile has-text-white"> 
                        <strong class="has-text-white">ADRESSE</strong><br/>
                        General Hotell<br/>
                        Regimentsveien 10<br/>
                        Helgelandsmoen<br/>
                        3512 Hønefoss
                    </p>
                </div>
                <div class="column is-one-third">
                    <p class="is-size-4 is-size-5-mobile has-text-white">
                        <strong class="has-text-white">E-POST</strong><br/>
                        <a href="mailto:resepsjonen@generalhotell.no?subject=Rombooking">Rombooking</a><br/>
                        <a href="mailto:booking@generalhotell.no?subject=Selskapsforespørsel">Selskapsbooking</a><br/>
                        <a href="mailto:booking@generalhotell.no?subject=Konferanseforespørsel">Konferansebooking</a><br/>
                        <a href="mailto:jonas@generalhotell.no?subject=Streaming">Strømme- eller videoproduksjon</a><br/>
                        <a href="mailto:jonas@generalhotell.no?subject=Events">Eventbooking</a><br/>
                        <a href="mailto:harald@generalhotell.no">Administrasjon</a><br/>
                        <a href="mailto:faktura@generalhotell.no">Fakturaer til oss</a>
                    </p>
                </div>
                <div class="column is-one-third">
                    <p class="is-size-4 is-size-5-mobile has-text-white">
                        <strong class="has-text-white">TELEFON</strong><br/>
                        32 16 00 00<br/>
                        <span class="is-size-5 is-size-6-mobile has-text-white">Vi ønsker ikke kontakt med telefonselgere. </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    title: 'Kontakt oss',
    metaInfo: {
        meta: [
        { name: 'description', content: 'All kontaktinformasjon du trenger for vårt hotell. Velkommen til General Hotell!'},
        { name: 'keywords', content: 'kontakt, kontakt hotell, hotell hønefoss, hotell i hønefoss' }
        ]
    },        
}
</script>

<style scoped>
.bak {
    background-color: #000;
    opacity: 0.7;
    display: block;
    padding: 10px 10px 10px 10px;
    margin-bottom:300px;
}
</style>